<div class="move-upward" style="background-image: url(./images/login3.jpg)">
    <h1 class="rs">Regulatory Surveillance and Management System</h1>
    <div id="page-wrapper" class="login-page background nopadding">
        <div class="dis-tbl">
            <div class="dis-tbl-cell">
                <div class="login-cntnt ">
                    <div class="login-box ">
                        <div class="log-bx-head defaultColor">
                            <img id="change-password-icon" alt="log-hed" src="/images/log-hed-ic.png">
                            <h4>Change Password</h4>
                        </div>
                        <div class="log-bx-cntnt">
                            <div class="alert alert-info">
                            <form [formGroup]="form" class="login-form">
                                <div class="input-group bottomClass">
                                    <span class="input-group-addon ">
                                        <i class="glyphicon glyphicon-user"></i>
                                    </span>
                                    <input class="form-control" formControlName="userName" id="userName" type="email" placeholder="User name"
                                        name="userName">
                                </div>
                                 @if(form.get('userName')?.hasError('required') && (form.get('userName')?.touched || form.get('userName')?.dirty)){
                                     <small class="error-message error-msg-username">User name is required</small>
                                    }
                                <div class="input-group bottomClass">
                                    <span class="input-group-addon">
                                        <span class="glyphicon glyphicon-lock"></span>
                                    </span>
                                    <input class="form-control" formControlName="oldPwd" id="oldPwd"
                                        [type]="showPassword ? 'text' : 'password'" placeholder="Old Password"
                                        name="password" required>
                                    <span class="input-group-addon removeBackgroud">
                                        @if(!showPassword){
                                        <span (click)="showPassword = !showPassword;"
                                            class="glyphicon glyphicon-eye-open eyeIcon"></span>
                                        }
                                        @if(showPassword){
                                        <span (click)="showPassword = !showPassword;"
                                            class="glyphicon glyphicon-eye-close eyeIcon"></span>
                                        }
                                    </span>
                                </div>
                                 @if(form.get('oldPwd')?.hasError('required') && (form.get('oldPwd')?.touched || form.get('oldPwd')?.dirty)){
                                     <small class="error-message error-msg-oldpwd">Old password is required</small>
                                    }
                                <div class="input-group bottomClass">
                                    <span class="input-group-addon">
                                        <span class="glyphicon glyphicon-lock"></span>
                                    </span>
                                    <input class="form-control" formControlName="newPwd" id="newPwd"
                                        [type]="showNewPassword ? 'text' : 'password'" placeholder="New Password"
                                        name="password" (input)="onPasswordInput()" required>
                                    <span class="input-group-addon removeBackgroud">
                                        @if(!showNewPassword){
                                        <span (click)="showNewPassword = !showNewPassword;"
                                            class="glyphicon glyphicon-eye-open eyeIcon"></span>
                                        }
                                        @if(showNewPassword){
                                        <span (click)="showNewPassword = !showNewPassword;"
                                            class="glyphicon glyphicon-eye-close eyeIcon"></span>
                                        }
                                    </span>
                                </div>
                                 @if((form.get('newPwd')?.touched || form.get('newPwd')?.dirty)){
                                     @if(form.get('newPwd')?.hasError('required')){
                                     <small class="error-message error-msg-newpwd">New password is required</small>
                                    }
                                   @if(form.get('newPwd')?.hasError('pattern')){
                                     <small class="error-message error-msg-newpwd">Min 8 char with upper,lower,number & special char</small>
                                  }
                                }
                                <div class="input-group bottomClass">
                                    <span class="input-group-addon">
                                        <span class="glyphicon glyphicon-lock"></span>
                                    </span>
                                    <input class="form-control" formControlName="confirmPwd" id="confirmPwd"
                                        [type]="showConfirmPassword ? 'text' : 'password'" (input)="onPasswordInput()"
                                        placeholder="Confirm Password" name="password" required>
                                    <span class="input-group-addon removeBackgroud">
                                        @if(!showConfirmPassword){
                                        <span (click)="showConfirmPassword = !showConfirmPassword;"
                                            class="glyphicon glyphicon-eye-open eyeIcon"></span>
                                        }
                                        @if(showConfirmPassword){
                                        <span (click)="showConfirmPassword = !showConfirmPassword;"
                                            class="glyphicon glyphicon-eye-close eyeIcon"></span>
                                        }
                                    </span>
                                </div>
                                @if((form.get('confirmPwd')?.touched || form.get('confirmPwd')?.dirty)){
                                 @if(form.get('confirmPwd')?.hasError('required')){
                                     <small class="error-message error-msg-confirmpwd">Confirm password is required</small>
                                    }
                                @if(form.hasError('passwordMismatch')){
                                     <small class="error-message error-msg-confirmpwd">New password & confirm password must match</small>
                                }
                            }
                                <div class="btn-container">
                                    <div class="btn-row">
                                        <button type="button" (click)="generateAutoPass()" [disabled] = isManualPassword
                                            class="btn btn-md btn-primary defaultBtnColor btn-padding mt-2">Auto
                                            Generate Random
                                            Password</button>
                                        <button type="button" (click)="resetUserPass()" [disabled]="form.invalid" 
                                            class="btn btn-md btn-primary defaultBtnColor btn-padding mt-2">Change
                                            Password</button>
                                    </div>
                                    <button type="button" (click)="routeTo('login')"
                                        class="btn btn-md btn-primary btn-block defaultBtnColor btn-padding btn-back">Cancel</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="footer">
        <p class="text-muted">
            <strong>Copyright </strong>&copy; RSMS 2019 All rights reserved
        </p>
    </div>
</div>